import Plot from "react-plotly.js";
import { Spinner } from "../spinner";
import { ModalHeader, ModalContent, Modal } from "semantic-ui-react";
import { useGetSkylineData } from "../CustomHooks";

const WindowOrSensorSkyline = ({ type, id, name, isVisible, handleClose }) => {
  const { apiResult } = useGetSkylineData({ id, type, isVisible });

  if (!isVisible) return null;

  return (
    <Modal
      closeOnEscape
      className="center-fixed"
      open={isVisible}
      onClose={handleClose}
      style={{
        width: "80vw",
        height: "80vh",
      }}
    >
      <ModalHeader>
        Skyline Visualization - {type === "sensor" ? "Sensor" : "Window"} {name}
      </ModalHeader>
      <ModalContent>
        {apiResult?.loading && (
          <div>
            <Spinner title="Loading..." />
          </div>
        )}

        {apiResult?.data && (
          <Plot
            data={apiResult?.data}
            layout={{
              margin: { t: 40, l: 40, r: 20, b: 40 },
            }}
            style={{ width: "100%", height: "100%" }}
            useResizeHandler={true}
          />
        )}
      </ModalContent>
    </Modal>
  );
};

export default WindowOrSensorSkyline;
